import {
  armarColumGrid,
  getDataColum,
  getDataColun,
  getDataRowStorage,
  setParametersSave,
  setParametersSaveMinuta,
  getParameterUp,
  onAddData,
  costoAjustado,
  minutaBackVersion,
  version,
} from './gridService'
import {FC, useEffect, useState, useCallback} from 'react'
import {AgGridTable} from '../../../utils/agGridTable/AgGridTable'
import {columnGrid} from '../../../utils/lunchGrid/ColumnGrid'
import {armarColum, armarRow} from '../minutaFood/services/serviceMinutaFood/serviceMinutaFood'
import {callSP, callSPUp} from '../../../../setup/axios/AxiosCallSP'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import {ModalForm} from '../../../utils/modal/ModalForm'
import {recetaContrato} from '../../../utils/interface/recetaContrato'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import * as contract from '../../redux/ContractRedux'
import {HeaderGrid} from './HeaderGrid'
import {useNavigate} from 'react-router-dom'
import {setLStorage, getLStorage} from '../../../../global.d'
import {AlertModal} from '../../../utils/modal/AlertModal'
import {success, warn} from '../../../utils/customToasd'
import {Loading} from '../../../utils/loadingR/Loading'
import {RootState} from 'setup'
import { getUserByToken } from 'app/helpers/getUserByToken'

const Grilla1: FC = () => {
  const dispatch = useDispatch()
  const [dataRowB, setDataRowB] = useState<columnGrid[]>([]) // función para organizar las columnas armarRow(minutaBase)
  const [dataRowP, setDataRowP] = useState<columnGrid[]>([]) // función para organizar las columnas armarRow(minutaBase)
  const [datacolumns, setDatacolumns] = useState<columnGrid[]>([])
  const [columnDefs, setColumDefs] = useState<any>()
  const [showModalMenu, setShowModalMenu] = useState(false)
  const [showBackAllMinuta, setShowBackAllMinuta] = useState(false)
  const [showSaveSend, setShowSaveSend] = useState(false)
  const navigate = useNavigate()
  const [recetasbyContrato, setRecetasbyContrato] = useState<recetaContrato[]>()
  const [idIngredientePrincipal, setIdIngredientePrincipal] = useState<any>({})
  const [recetasbyContratoFilter, setRecetasbyContratoFilter] = useState<recetaContrato[]>()
  const [showAll, setShowAll] = useState<boolean>(false)
  const [esOtroIngredinte, setEsOtroIngredinte] = useState<boolean>(false)
  const [datatableCol, setDatatableCol] = useState<any>([])
  const [back, setBack] = useState(false)
  const [backAll, setBackAll] = useState(false)
  const [initialState, setInitialState] = useState<any>([])
  const [parameters, setParameters] = useState<any>([])
  const [parameterSelected, setParameterSelected] = useState<dataRecetaSave>()
  const [datosContrato, setDatosContrato] = useState<any>()
  const [params, setParams] = useState<any>()
  let pinnedRow: any = []
  const [load, setLoad] = useState(false)
  const [contrato, setContrato] = useState<string>('')
  const accessToken: any = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)
  const [estructuraPadre, setEstructuraPadre] = useState<any>([])

  const user: any = useSelector<RootState>(({ auth }) => auth.user, shallowEqual)
  
  const getVersion = async () => {
    const user: any = await getUserByToken(accessToken)
    if (user.role == '12') return '3'
    if (user.role == '13') return '2'
  
    return '2'
  }

  const data = async (dataColumn: columnGrid[]) => {
    setLoad(true)
    const idContrato = await getLStorage('idContratoGrilla')
    const idMinuta = await getLStorage('idMinutaGrilla')
    const response: any = await callSP('amd_getDatosContrato', [
      {text: 'contrato', value: idContrato},
      {text: 'id_minuta', value: idMinuta},
    ])
    if (response.status === 200) {
      setDatosContrato(response.data.result[0])
      dispatch(contract.actions.setInfoData(response.data.result[0]))
    }

    const dataSP: any = await callSP('amd_getRecetasByContrato', [
      {text: 'contrato', value: idContrato},
      {text: 'id_minuta', value: idMinuta},
    ])

    setColumDefs(
      armarColumGrid(
        dataColumn,
        dataSP.data.result,
        {
          setDataRowB: setDataRowB,
          parameters: parameters,
          setParameters: setParameters,
          setShowModalMenu: setShowModalMenu,
          setLStorage: setLStorage,
        },
        setDataRowB
      )
    )
    setLoad(false)
  }

  const getData = async () => {
    const newDataRow = async (dataRowB: any) => {
      const validar: any = {}
      const estructurasPadre = dataRowB.map((item: any, i: any, array: any) => {
        const data = {
          estructuraPadre: item.estructura_padre0,
          cant: dataRowB.filter((e: any) => e.estructura_padre0 === item.estructura_padre0).length,
          hidden: !!validar[item.estructura_padre0],
          ...item,
        }
        validar[item.estructura_padre0] = 1
        return data
      })
      return estructurasPadre
    }

    const idContrato = await getLStorage('idContratoGrilla')
    const idMinuta = await getLStorage('idMinutaGrilla')
    let dataContratoGrilla = await getLStorage('dataContratoGrilla')
    dataContratoGrilla = JSON.parse(dataContratoGrilla)
    setContrato(idContrato)
    const dataC = await getDataColum(idContrato, accessToken, setEstructuraPadre, dataContratoGrilla, idMinuta)
    setInitialState(dataC)
    const dataColum = armarColum(dataC)
    const dataRow = armarRow(dataC)
    setDatacolumns(dataColum)

    const newData = await newDataRow(dataRow)

    setDataRowB(newData.slice(4, newData.length))
    setDataRowP(newData.slice(0, 4))
    data(dataColum)
    setLStorage('dataRow', [newData.slice(4, dataRow.length)])
    fetchData('amd_getRecetasByContrato', [
      {text: 'contrato', value: idContrato},
      {text: 'id_minuta', value: idMinuta},
    ])
  }

  useEffect(() => {
    try {
      setLoad(true)
      setLStorage('setDataRowB', setDataRowB)
      setDatatableCol(getDataColun(filter))
      dispatch(contract.actions.setInfo(true))
      getData()
      return () => {
        dispatch(contract.actions.setInfo(false))
        dispatch(contract.actions.setInfoData(undefined))
      }
    } catch (error) {
      Promise.reject(error)
    }
  }, [estructuraPadre])

  useEffect(() => {
    if (showAll) {
      setRecetasbyContratoFilter(
        recetasbyContrato?.filter(
          (item) =>
            item.id_alergeno === idIngredientePrincipal.id_alergeno &&
            item.id_sellos === idIngredientePrincipal.id_sellos &&
            (item.id_estilo_aliminatacion === idIngredientePrincipal.id_estilo_aliminatacion ||
              item.id_intolerancia === idIngredientePrincipal.id_intolerancia)
        )
      )
    } else {
      setRecetasbyContratoFilter(
        recetasbyContrato?.filter(
          (item) =>
            item.Idtipoingprincipal === idIngredientePrincipal.idIngrediente &&
            item.id_alergeno === idIngredientePrincipal.id_alergeno &&
            item.id_sellos === idIngredientePrincipal.id_sellos &&
            (item.id_estilo_aliminatacion === idIngredientePrincipal.id_estilo_aliminatacion ||
              item.id_intolerancia === idIngredientePrincipal.id_intolerancia)
        )
      )
    }
  }, [showAll])

  const fetchData = async (name: string, parameters: any) => {
    const response: any = await callSP(name, parameters)
    if (response.status === 200) {
      setRecetasbyContrato(response.data.result)
      setRecetasbyContratoFilter(response.data.result)
    }
    setLoad(false)
  }

  const filter = useCallback(
    async (params: any, confirm: boolean) => {
      const ing = await localStorage.getItem('ingredienteSeleccionado2')
      if (ing !== null) {
        const datarow = await getDataRowStorage()
        if (datarow !== null) {
          const data: itemSelec = JSON.parse(ing)
          let addData = false
          let getDataRow = JSON.parse(datarow)
          const datar = JSON.parse(datarow)
          getDataRow[0].forEach((item: any, key: number) => {
            if (item['fecha' + data.idColumn] === data.fecha && data.numRow === key) {
              if (
                item['id_receta' + data.idColumn] !== params.data.rec_codigo &&
                item['receta' + data.idColumn] !== params.data.rec_nombre
              ) {
                if (
                  item['idIngredientePrincipal' + data.idColumn] !==
                    params.data.Idtipoingprincipal &&
                  !confirm
                ) {
                  setParams(params)
                  setEsOtroIngredinte(true)
                } else {
                  item['id_receta' + data.idColumn] = params.data.rec_codigo
                  item['receta' + data.idColumn] = params.data.rec_nombre
                  item['className' + data.idColumn] = 'ultimo-cambio'

                  const p = parameters
                  const pSelected = getLStorage('parameterSelected')
                  if (pSelected) {
                    const finded = p.find((e: any) => e.id === pSelected?.id)
                    
                    if (finded === undefined) {
                      p.push({
                        id: pSelected?.id,
                        id_minuta: pSelected?.id_minuta,
                        id_receta: params.data.rec_codigo,
                        ponderado: pSelected?.ponderado,
                      })
                    } else {
                      const index = p.findIndex((e: any) => e.id === pSelected?.id)
                      finded.id_receta = params.data.rec_codigo
                      p.splice(index, 1, finded)
                    }
                    setParameters(p)
                  }
                  addData = true
                }
              }
            }
          })
          onAddData(addData, datar, getDataRow, setLStorage, setDataRowB)
        }
      }
      setShowModalMenu(false)
    },
    [setDatatableCol]
  )

  const getDataOtroIngrediente = async (confirm: boolean) => {
    filter(params, confirm)
  }

  useEffect(() => {
  }, [parameters])

  useEffect(() => {
  }, [parameterSelected])

  useEffect(() => {
    const data = recetasbyContrato?.filter(
      (item) => item.Idtipoingprincipal === idIngredientePrincipal.idIngrediente
    )
    if (recetasbyContrato) {
      setRecetasbyContratoFilter(data)
    }
  }, [idIngredientePrincipal])

  useEffect(() => {
    backData()
  }, [back])

  const backData = async () => {
    const datarow = await getDataRowStorage()
    if (datarow !== null) {
      let datr = JSON.parse(datarow)
      datr = datr.slice(1)
      if (datr.length > 0) {
        setDataRowB(datr[0])
        setLStorage('dataRow', datr)
      }
    }
  }

  useEffect(() => {
    const data = recetasbyContrato?.filter(
      (item: any) =>
        item.Idtipoingprincipal === idIngredientePrincipal.idIngrediente &&
        item.id_alergeno === idIngredientePrincipal.id_alergeno &&
        item.id_sellos === idIngredientePrincipal.id_sellos &&
        (item.id_estilo_aliminatacion === idIngredientePrincipal.id_estilo_aliminatacion ||
          item.id_intolerancia === idIngredientePrincipal.id_intolerancia)
    )
    if (recetasbyContrato) {
      setRecetasbyContratoFilter(data)
    }
  }, [idIngredientePrincipal])

  const rowClassRules: any = {
    feriado: (params: any) => {
      return params.data.EXITE > 0
    },
  }

  useEffect(() => {
    restartDataRow()
  }, [backAll])

  const restartDataRow = async () => {
    const datarow = await getDataRowStorage()
    if (datarow !== null) {
      let datr = JSON.parse(datarow)
      datr = datr.slice(datr.length - 1)
      if (datr.length > 0) {
        setDataRowB(datr[0])
        setLStorage('dataRow', datr)
      }
    }
  }

  const onSave = async (type: string) => {
    if (parameters.length) {
      const p: any = []
      const idContrato = await getLStorage('idContratoGrilla')
      const idMinuta = await getLStorage('idMinutaGrilla')
      parameters.forEach( async (e: any) => {
        p.push(
          setParametersSaveMinuta(e.id.toString(), idContrato, idMinuta, e.id_receta.toString(), e.ponderado.toString(), type, await getVersion(), '0')
        )
      })
      const paramsUp = getParameterUp(p)
      const response: any = await callSPUp('amd_guardar_minuta', p)
      if (response.data.result) {
        success('Receta actualizada con exito!')
      }
    } else {
      warn('No hay cambio que guardar!')
    }
  }

  const onClickAgGrid = (item: any, agGrid: any, event: any) => {
    if (item[0]?.open) {
      if (event.column !== undefined) {
        const idColumn = event.column.colId.charAt(event.column.colId.length - 1)
        const json = {
          idIngrediente: event.data['idIngredientePrincipal' + idColumn],
          id_receta: event.data['id_receta' + idColumn],
          fecha: event.data['fecha' + idColumn],
          numRow: event.rowIndex,
          idColumn: idColumn,
          id_alergeno: event.data['id_alergeno' + idColumn],
          id_categoria_dietetica: event.data['id_categoria_dietetica' + idColumn],
          id_estilo_aliminatacion: event.data['id_estilo_aliminatacion' + idColumn],
          id_intolerancia: event.data['id_intolerancia' + idColumn],
          id_sellos: event.data['id_sellos' + idColumn],
        }
        setLStorage('ingredienteSeleccionado2', json)
        setIdIngredientePrincipal(json)

        const p = {
          id: event.data['id' + idColumn],
          id_receta: event.data['id_receta' + idColumn],
          ponderado: event.data['ponderado' + idColumn],
          fecha: event.data['fecha' + idColumn],
        }
        setParameterSelected(p)
        setLStorage('parameterSelected', p)
        setShowModalMenu(item[0].open)
      }
    }
  }

  const onCellValueChangedAgGrid = async (params: any) => {
    const datarow = await getDataRowStorage()
    if (datarow !== null) {
      if (params.column !== undefined) {
        let addData = false
        let getDataRow = JSON.parse(datarow)
        const datar = JSON.parse(datarow)

        const idColumn = params.column.colId.charAt(params.column.colId.length - 1)
        const pSelected = {
          id: params.data['id' + idColumn],
          id_receta: params.data['id_receta' + idColumn],
          ponderado: params.data['ponderado' + idColumn],
          fecha: params.data['fecha' + idColumn],
          numRow: params.rowIndex,
          idColumn: idColumn,
        }
        setLStorage('parameterSelected', pSelected)

        getDataRow[0].forEach((item: any, key: number) => {
          if (
            item['fecha' + idColumn] === params.data['fecha' + idColumn] &&
            params.rowIndex === key
          ) {
            if (item['ponderado' + idColumn] !== params.data['ponderado' + idColumn]) {
              item['ponderado' + idColumn] = params.data['ponderado' + idColumn]
              item['className2' + idColumn] = 'ultimo-cambio'

              const p = parameters
              

              if (pSelected) {
                const finded = p.find((e: any) => e.id === pSelected?.id)
                
                if (finded === undefined) {
                  p.push({
                    id: pSelected?.id,
                    id_receta: pSelected?.id_receta,
                    ponderado: pSelected?.ponderado,
                  })
                } else {
                  const index = p.findIndex((e: any) => e.id === pSelected?.id)
                  finded.ponderado = pSelected?.ponderado
                  p.splice(index, 1, finded)
                  // p.push(finded)
                  
                }
                setParameters(p)
              }

              addData = true
            }
          }
        })
        onAddData(addData, datar, getDataRow, setLStorage, setDataRowB)
        costoAjustado(getDataRow, dataRowP, datacolumns, params, setDataRowP)
      }
    }
  }

  useEffect(() => {
  }, [dataRowP])

  const onPrint = (fileName: string) => {
    const link = document.createElement('a')
    link.href = require(`./Propuesta-Proceso-a-barrer-y-a-proceso.pdf`)
    link.target = '_blank'
    link.download = `${fileName}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const onExport = () => {
  }

  const TablaEstructuraPadre = () => {
    const validar: any = {}
    const estructurasPadre = dataRowB.map((item: any, i, array) => {
      const data = {
        estructura_padre0: item.estructura_padre0,
        cant: dataRowB.filter((e: any) => e.estructura_padre0 === item.estructura_padre0).length,
        hidden: !!validar[item.estructura_padre0],
        ...item,
      }

      validar[item.estructura_padre0] = 1
      return data
    })

    const columns = [
      {
        key: 1,
        estructura_padre0: ' ',
        hidden: false
      },
      {
        key: 2,
        estructura_padre0: ' ',
        hidden: false
      },
      {
        key: 3,
        estructura_padre0: ' ',
        hidden: false
      },
      {
        key: 4,
        estructura_padre0: ' ',
        hidden: false
      },
    ]


    return (
      <div
        className='h-100'
        style={{
          borderRadius: '5px 0px 0px 5px',
          overflow: 'hidden',
        }}
      >
        <table>
          <thead>
            <tr>
              <th
              className='text-start'
                style={{
                  height: '50px',
                  borderCollapse: 'collapse',
                  padding: '0 1.5rem',
                  background: '#2A2889',
                  color: '#fff',
                  minWidth: '180px'
                }}
              >Acompañamiento</th>
            </tr>
            {columns.map(({estructura_padre0, cant, hidden, color1}: any, key: number) => (
              <tr className=''>
                <td
                  style={{
                    height: '30px',
                    border: '1px solid  #dde2eb',
                    borderCollapse: 'collapse',
                    padding: '0 1rem',
                    background: 'skyblue',
                  }}
                  className='border'
                >
                  {!hidden ? estructura_padre0 : ''}
                </td>
              </tr>
            ))}
          </thead>
          <tbody className='ag-pinned-left-cols-container'>
            {estructurasPadre.map(({estructura_padre0, cant, hidden, color1}: any, key: number) => {
              return (
                <tr className='ag-row-level-0'>
                  <td
                    style={{
                      height: estructura_padre0 === ' ' ? '31px' : '42px',
                      border: '1px solid  #dde2eb',
                      borderCollapse: 'collapse',
                      padding: '0 1rem',
                    }}
                    className='border'
                  >
                    {!hidden ? estructura_padre0 : ''}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
  
  return (
    <>
      {/* begin::arrow table */}
      <Loading open={load} />
      <HeaderGrid
        back={async () => {
          setBack(!back)
          // minutaBackVersion(contrato, version, setLoad)
        }}
        backAll={() => setShowBackAllMinuta(true)}
        onSave={() => onSave('3')}
        onSaveSend={() => setShowSaveSend(true)}
        onExportMinuta={() => onExport()}
        onExportMinutaCliente={() => onExport()}
        onPrintMinuta={() => onPrint('Minuta')}
        onPrintMinutaCliente={() => onPrint('Minuta-cliente')}
      />

      <div className='d-flex'>
        {dataRowB && <TablaEstructuraPadre />}
        <AgGridTable
          columnDefs={columnDefs}
          dataRow={dataRowB}
          paginationPageSize={20}
          style={{height: '80vh', width: '100%'}}
          rowPinned={dataRowP}
          onClick={(item: any, agGrid, event) => {
            onClickAgGrid(item, agGrid, event)
          }}
          onCellValueChanged={(params) => {
            onCellValueChangedAgGrid(params)
            setTimeout(() => {
              params.api.refreshCells({force: true})
            }, 400)
          }}
        />
      </div>

      <Autocomplete
        disablePortal
        id='combo-box-demo'
        options={[]}
        sx={{width: 300}}
        renderInput={(params) => <TextField {...params} label='Estructuras' />}
      />

      {showModalMenu && (
        <ModalForm
          initialValues={{
            all: false,
            ponderacion: 0,
          }}
          show={showModalMenu}
          showClose={false}
          showSave={false}
          onSubmit={(_value, formikProps) => {
            formikProps.setFieldValue('receta', 'papas con pescados')
            setTimeout(() => {
              setShowModalMenu(false)
            }, 5000)
          }}
          close={() => {
            setShowModalMenu(false)
          }}
          arrayInput={[
            {
              type: 'text',
              label: 'Ponderación',
              placeholder: 'Ingrese ponderación',
              className: 'input-ponderacion',
              campo: 'ponderacion',
            },
            {
              label: 'Ver todo',
              campo: 'all',
              type: 'button',
              placeholder: 'Ingrese cantidad',
              className: 'btn btn-info',
              onClick: (params: any) => {
                setShowAll(!showAll)
              },
            },
          ]}
          title={'Filtrar Menú'}
          showTable={true}
          tableType='datatable'
          tableSelectableRows={false}
          modalFullscreen={true}
          rows={recetasbyContratoFilter}
          colum={datatableCol}
          tableConditionalRowStyles={rowClassRules}
        />
      )}

      {esOtroIngredinte && (
        <AlertModal
          show={esOtroIngredinte}
          title='Confirmación'
          message='Esta realizando cambio de ingrediente principal, ¿esta seguro?'
          close={() => {
            setEsOtroIngredinte(false)
          }}
          save={() => {
            getDataOtroIngrediente(true)
            setEsOtroIngredinte(false)
          }}
        />
      )}

      {showBackAllMinuta && (
        <ModalForm
          initialValues={{
            ok: true,
            true: true,
          }}
          size='sm'
          show={showBackAllMinuta}
          showClose={true}
          showSave={true}
          showBody={false}
          saveName={'Aceptar'}
          onSubmit={(_value, formikProps) => {
            setBackAll(!backAll)
            minutaBackVersion(contrato, version, setLoad)
            setShowBackAllMinuta(false)
          }}
          close={() => {
            setShowBackAllMinuta(false)
          }}
          title={'Desea regresar todos los cambios?'}
          modalFullscreen={false}
        />
      )}

      {showSaveSend && (
        <ModalForm
          initialValues={{
            ok: true,
            true: true,
          }}
          size='sm'
          show={showSaveSend}
          showClose={true}
          showSave={true}
          showBody={false}
          onSubmit={(_value, formikProps) => {
            onSave('4')
            setShowSaveSend(false)
          }}
          close={() => {
            setShowSaveSend(false)
          }}
          title={'Desea guardar y enviar todos los cambios?'}
          modalFullscreen={false}
        />
      )}
    </>
  )
}
export interface IGrilla1 {
  id: number
  name: string
  lastName: string
  age: number
}
interface params {
  dataSP: any
  dataSelected: any
  params: any
}
export interface itemSelec {
  dataRowB: any
  idColumn: number
  idIngrediente: number
  id_receta: number
  fecha: string
  numRow: number
  idGrid?: number
}

interface dataRecetaSave {
  id: string
  id_receta: string
  ponderado: string
}

export {Grilla1}
